var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-view application-choice-page"
  }, [_c('client-financing-offer-pop-up', {
    attrs: {
      "show": _vm.showPdf,
      "mortgage-applications": _vm.mortgageApplications,
      "mortgage": _vm.mortgage
    }
  }), _c('handlers-wrapper-button', {
    attrs: {
      "floating-handlers": _vm.floatingHandler,
      "handlers": _vm.getHandlers()
    }
  }), _c('div', {
    staticClass: "div-block-30 applicants-strip"
  }, [_c('choice-user-detail-item', {
    attrs: {
      "mortgage-id": _vm.mortgage.id,
      "client": _vm.applicant,
      "client-info": _vm.getApplicantInfo(),
      "co-applicant-present": !!_vm.coApplicant,
      "missing-info": _vm.missingInformation,
      "compact": ""
    }
  }), _c('choice-user-detail-item', {
    attrs: {
      "mortgage-id": _vm.mortgage.id,
      "client": _vm.coApplicant,
      "client-info": _vm.getCoApplicantInfo(),
      "co-applicant-present": !!_vm.coApplicant,
      "missing-info": _vm.missingInformation,
      "compact": ""
    }
  })], 1), _vm.missingInformation ? _c('div', {
    staticClass: "empty-bag-wrapper"
  }, [_c('img', {
    attrs: {
      "src": require("@/images/default-page.choices.png"),
      "width": "200",
      "height": "175",
      "alt": ""
    }
  }), _c('div', {
    staticStyle: {
      "max-width": "35%"
    }
  }, [_c('span', {
    staticClass: "txt-center"
  }, [_vm._v(" Zatiaľ tu nič nie je, prvé vypočítané ponuky sa tu zobrazia po doplnení "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.missingInformationStatement)
    }
  })])])]) : _vm._e(), _vm.limitsLoader && !_vm.missingInformation ? _c('div', {
    staticClass: "div-block-105"
  }, [_c('div', {
    staticClass: "property-priority-row"
  }, [_c('founded-property', {
    attrs: {
      "mortgage-id": _vm.mortgage.id
    }
  })], 1), _c('section', {
    staticClass: "loan-purpose-section"
  }, [_c('div', {
    staticClass: "loan-purpose-section-heading"
  }, [_vm._m(0), _c('div', {
    staticClass: "loan-purpose-total"
  }, [_c('span', [_vm._v("Požadovaný úver spolu")]), _c('strong', [_vm._v(_vm._s(_vm._f("dotTheAmount")(_vm.totalRequestedAmount)) + " EUR")])])]), _c('div', {
    staticClass: "loan-purpose-grid"
  }, [_c('div', {
    staticClass: "loan-purpose-card amount-acquisition"
  }, [_vm._m(1), _c('nadobudnutie-wrapper', {
    attrs: {
      "mortgage": _vm.mortgage,
      "total-limit": _vm.maxLimit,
      "loan-purpose": _vm.loanPurpose
    }
  })], 1), _c('div', {
    staticClass: "loan-purpose-card amount-refinancing"
  }, [_vm._m(2), _c('refinancovanie-wrapper', {
    attrs: {
      "mortgage": _vm.mortgage,
      "total-limit": _vm.maxLimit,
      "loan-purpose": _vm.loanPurpose,
      "clients-info": {
        applicantInfo: _vm.getApplicantInfo(),
        coApplicantInfo: _vm.getCoApplicantInfo()
      }
    }
  })], 1), _c('div', {
    staticClass: "loan-purpose-card amount-unrestricted"
  }, [_vm._m(3), _c('ucelova-cast-wrapper', {
    attrs: {
      "mortgage": _vm.mortgage,
      "total-limit": _vm.maxLimit,
      "loan-purpose": _vm.loanPurpose
    }
  })], 1)])]), _c('mortgage-applications-choice-wrapper', {
    staticClass: "offers-results",
    attrs: {
      "mortgage": _vm.mortgage,
      "mortgage-offers": _vm.mortgageApplications
    }
  })], 1) : _vm._e(), !_vm.limitsLoader && !_vm.missingInformation ? _c('div', {
    staticClass: "limits-loader"
  }, [_c('img', {
    staticClass: "image-limits-loading",
    attrs: {
      "src": require("@/images/limits-loader.png"),
      "alt": ""
    }
  }), _c('span', {
    staticClass: "blc-color MGright20px"
  }, [_vm._v("prepočítavame limity na nastavenie požadovanej výšky úveru")]), _c('v-progress-circular', {
    staticClass: "loading-spinner small transparent",
    attrs: {
      "indeterminate": ""
    }
  })], 1) : _vm._e()], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "loan-purpose-title"
  }, [_vm._v("Rozdelenie úveru podľa účelu")]), _c('div', {
    staticClass: "loan-purpose-description"
  }, [_vm._v("Každý stĺpec predstavuje samostatný účel financovania.")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "purpose-card-heading"
  }, [_c('span', {
    staticClass: "purpose-number"
  }, [_vm._v("01")]), _c('div', [_c('div', {
    staticClass: "purpose-name"
  }, [_vm._v("Nadobudnutie")]), _c('div', {
    staticClass: "purpose-description"
  }, [_vm._v("Kúpa alebo výstavba nehnuteľnosti")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "purpose-card-heading"
  }, [_c('span', {
    staticClass: "purpose-number"
  }, [_vm._v("02")]), _c('div', [_c('div', {
    staticClass: "purpose-name"
  }, [_vm._v("Refinancovanie")]), _c('div', {
    staticClass: "purpose-description"
  }, [_vm._v("Splatenie existujúcich úverov")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "purpose-card-heading"
  }, [_c('span', {
    staticClass: "purpose-number"
  }, [_vm._v("03")]), _c('div', [_c('div', {
    staticClass: "purpose-name"
  }, [_vm._v("Bezúčelová časť")]), _c('div', {
    staticClass: "purpose-description"
  }, [_vm._v("Doplnková časť bez dokladovania účelu")])])]);

}]

export { render, staticRenderFns }